/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Support_DescriptionInputs */

const en_settings_support_description = /** @type {(inputs: Settings_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get help from our support team.`)
};

const es_settings_support_description = /** @type {(inputs: Settings_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtén ayuda de nuestro equipo de soporte.`)
};

/**
* | output |
* | --- |
* | "Get help from our support team." |
*
* @param {Settings_Support_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_support_description = /** @type {((inputs?: Settings_Support_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Support_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_support_description(inputs)
	return en_settings_support_description(inputs)
});